/**
 * Tax Savings Calculator: computes order value × state tax rate.
 */
const STATE_TAX_RATES = {
  Alabama: 4,
  Alaska: 0,
  Arizona: 5.6,
  Arkansas: 6.5,
  California: 7.25,
  Colorado: 2.9,
  Connecticut: 6.35,
  Delaware: 0,
  Florida: 6,
  Georgia: 4,
  Hawaii: 4,
  Idaho: 6,
  Illinois: 6.25,
  Indiana: 7,
  Iowa: 6,
  Kansas: 6.5,
  Kentucky: 6,
  Louisiana: 4.45,
  Maine: 5.5,
  Maryland: 6,
  Massachusetts: 6.25,
  Michigan: 6,
  Minnesota: 6.875,
  Mississippi: 7,
  Missouri: 4.225,
  Montana: 0,
  Nebraska: 5.5,
  Nevada: 6.85,
  'New Hampshire': 0,
  'New Jersey': 6.625,
  'New Mexico': 5,
  'New York': 4,
  'North Carolina': 4.75,
  'North Dakota': 5,
  Ohio: 5.75,
  Oklahoma: 4.5,
  Oregon: 0,
  Pennsylvania: 6,
  'Rhode Island': 7,
  'South Carolina': 6,
  'South Dakota': 4.5,
  Tennessee: 7,
  Texas: 6.25,
  Utah: 6.1,
  Vermont: 6,
  Virginia: 5.3,
  Washington: 6.5,
  'West Virginia': 6,
  Wisconsin: 5,
  Wyoming: 4,
};

function formatCurrency(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

function formatRate(rate) {
  const formatted = Number.isInteger(rate) ? String(rate) : String(rate);
  return `${formatted}%`;
}

function initTaxCalculator(root) {
  const stateSelect = root.querySelector('[data-tax-state]');
  const orderSlider = root.querySelector('[data-tax-order-value]');
  const orderValueDisplay = root.querySelector('[data-tax-order-display]');
  const savingsDisplay = root.querySelector('[data-tax-savings]');
  const contextDisplay = root.querySelector('[data-tax-context]');

  if (!stateSelect || !orderSlider || !savingsDisplay) return;

  const update = () => {
    const state = stateSelect.value;
    const rate = STATE_TAX_RATES[state] ?? 0;
    const orderValue = Number(orderSlider.value);
    const savings = (orderValue * rate) / 100;

    if (orderValueDisplay) {
      orderValueDisplay.textContent = formatCurrency(orderValue);
    }

    orderSlider.setAttribute('aria-valuenow', String(orderValue));
    savingsDisplay.textContent = formatCurrency(savings);

    if (contextDisplay) {
      contextDisplay.innerHTML = `That's <strong>${formatRate(rate)} saved</strong> vs buying locally in ${state}.`;
    }

    const min = Number(orderSlider.min);
    const max = Number(orderSlider.max);
    const percent = max > min ? ((orderValue - min) / (max - min)) * 100 : 0;
    orderSlider.style.setProperty('--slider-progress', `${percent}%`);
  };

  stateSelect.addEventListener('change', update);
  orderSlider.addEventListener('input', update);
  update();
}

function initAllTaxCalculators(container = document) {
  container.querySelectorAll('.tax-calculator[data-section-id]').forEach(initTaxCalculator);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllTaxCalculators());
} else {
  initAllTaxCalculators();
}

document.addEventListener('shopify:section:load', (event) => initAllTaxCalculators(event.target));
